// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610141048/js/" + chunkId + "." + {"44":"d465b325","225":"0506d9fb","481":"c8397faf","486":"b713759f","770":"a1e92caf"}[chunkId] + ".0.015613444551046407.chunk.js";
};